<template>
  <div class="searchlinLongPage">
    <div class="searchTit clearfix">
      <a href="javascript:void(0);" class="fl" @click="goBack">
        <van-icon name="arrow-left" />
      </a>
      <p>搜索营造林地</p>
    </div>

    <div class="searchBox">
      <van-cell-group>
        <van-field
          v-model="searchValue.zlDl"
          :label="$t('common.dileiTit') + '：'"
          :placeholder="$t('searchMsg.diLeiTitleTip')"
          clickable
        />
        <van-field
          v-model="searchValue.xiaoBan"
          label="小班号："
          :placeholder="$t('searchMsg.numberTitleTip')"
          clickable
        />
        <van-field
          v-model="searchArea"
          :label="$t('common.politicalTit') + '：'"
          :placeholder="$t('searchMsg.searchTit')"
          readonly
          center
          @click="areaShowPicker = true"
          class="searchType"
        ></van-field>
        <van-button type="primary" size="small" @click="reloadResultList">{{
          $t("common.search")
        }}</van-button>
      </van-cell-group>
    </div>
    <div :class="['searchMain', this.showNonePage == true ? 'hideText' : '']">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        :offset="100"
        :finished-text="$t('common.noneMore')"
        class="resultList"
      >
        <van-cell
          v-for="item in resultData"
          :key="item.id"
          class="item"
          @click="setMap(item)"
        >
          <p class="clearfix">{{ item.regionName }}</p>
          <p class="clearfix">
            <span>小班号：{{ item.xiaoBan }}</span>
            <span>造林类型：{{ item.zlDl }}</span>
          </p>
        </van-cell>
      </van-list>
      <div class="nonePage" v-if="showNonePage">
        <img :src="nonePng" alt />
        <p>{{ $t("common.noDataTip") }}</p>
      </div>
    </div>
    <!-- 弹出层 -->
    <!-- 省、市、县/区、乡/镇、村两级联动 -->
    <van-popup v-model="areaShowPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="citys"
        value-key="zqName"
        :cancel-button-text="$t('searchMsg.clearText')"
        @cancel="onClearArea"
        @confirm="onSaveArea"
      />
    </van-popup>
    <!-- 林地详情 弹框 -->
    <div class="forestStyle" v-if="showYzlType">
      <div class="zgc">
        <a href="javascript:void(0);" @click="closePage">
          <i class="van-icon van-icon-arrow-left"></i>
        </a>
        <p>详情</p>
      </div>
      <yzld-msg
        :param="{
          id: this.dataInfo.objid,
          type: this.dataInfo.type,
          showMap: false,
        }"
      ></yzld-msg>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/

import yzldMsg from "../universal/yzldMsg";
import { getaeraList } from "@/utils/common";
import nonePng from "@/assets/none.png";
import { mapState } from "vuex";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";

export default {
  name: "searchYzld",
  components: {
    yzldMsg,
  },
  data() {
    return {
      editType: true, //防止搜索多次点击
      nonePng: nonePng, //默认图片
      showNonePage: false, //
      searchArea: "",
      searchValue: {
        zlDl: "",
        xiaoBan: "",
        zqCode: "", //城市区域码
        selectType: "2",
      }, //搜索值
      resultData: [],
      areaShowPicker: false, //
      backstagelists: [],
      page: 0,
      pageSize: 10,
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      citys: [],
      showYzlType: false, //是否显示林地详情
      dataInfo: "", //向子组件传值
      clientType: "", //手机类型
    };
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(() => {
      this.initPage();
      this.getCitys();
    });
  },

  methods: {
    async getCitys() {
      this.citys = await getaeraList(
        this.searchObj.zqCode ? this.searchObj.zqCode : this.userinfo.zqCode
      );
    },
    initPage() {
      if (this.userinfo && this.searchObj && this.userinfo.zqCode) {
        // this.$set(this.searchValue, "gridType", this.searchObj.zrqlx);
        // this.$set(this.searchValue, "objid", this.searchObj.objid);
        this.$set(
          this.searchValue,
          "zqCode",
          this.searchObj.zqCode ? this.searchObj.zqCode : this.userinfo.zqCode
        );
        // }
        this.getTest();
      }
    },
    getTest() {
      let _this = this;

      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.search
        .resourceZaolinList(_this.page, _this.pageSize, _this.searchValue)
        .then((res) => {
          if (res.code == "1") {
            let total = parseInt(res.data.total);
            _this.commentCount = total;
            _this.backstagelists = res.data.list;

            _this.viewLists();
            // 加载状态结束
            _this.editType = true;
            _this.loading = false;
            if (_this.page * 10 >= total) {
              _this.finished = true;

              console.log("加载完成");
            }
          } else {
            _this.editType = true;
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
    viewLists() {
      this.resultData = this.resultData.concat(this.backstagelists);
      if (this.resultData.length < 1) {
        this.showNonePage = true;
      } else {
        this.showNonePage = false;
      }
    },

    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 500);
    },
    reloadResultList() {
      let _this = this;
      if (_this.editType) {
        _this.editType = false;
        _this.showNonePage = false;
        _this.loading = true; //是否处于加载状态
        _this.finished = false;
        _this.searchValue.zqCode == ""
          ? (_this.searchValue.zqCode = _this.searchObj.zqCode
              ? _this.searchObj.zqCode
              : _this.userinfo.zqCode)
          : (_this.searchValue.zqCode = _this.searchValue.zqCode);
        _this.page = 0;
        _this.commentCount = 0;
        _this.resultData = [];
        _this.getTest();
      } else {
        _this.$toast(_this.$t("common.moreClickToastMsg"));
      }
    },
    onSaveArea(value, index) {
      this.searchArea = value[0] + value[1];
      this.searchValue.zqCode = this.citys[index[0]].children[index[1]].zqCode;
      this.areaShowPicker = false;
    },
    onClearArea(value, index) {
      //清空政区内容
      this.searchArea = "";
      this.searchValue.zqCode = "";
      this.areaShowPicker = false;
    },
    goBack() {
      let _this = this;
      _this.$store.commit("SetcloseShowType", "open");
      _this.$emit("changeType", true);
    },
    setMap(data) {
      // 接口信息未提供objid
      // this.dataInfo = {
      //   objid: data.objid,
      //   type: "LAYER_TYPE_010",
      // };
      this.dataInfo = {};
      console.log(data, "data");
      this.$set(this.dataInfo, "objid", data.objid);
      this.$set(this.dataInfo, "type", "LAYER_TYPE_010");
      console.log(this.dataInfo, "将要穿的值");
      this.showYzlType = true; //显示营造林地
      this.$store.commit("SetcloseShowType", "close");

      this.$emit("getMapOptions", this.dataInfo);
    },
    closePage() {
      this.showYzlType = false; //显示林地
      this.$store.commit("SetcloseShowType", "open");
    },
  },
  computed: {
    ...mapState(["userinfo", "searchObj"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        let _this = this;
        // _this.searchValue.zqCode = userinfo.zqCode;

        if (this.userinfo && this.searchObj) {
          _this.initPage();
        }
      },
      deep: true,
    },
    searchObj: {
      handler: function () {
        let _this = this;
        // let splitText = this.searchObj.zrqlx.substring(4, 8);
        // if (splitText == "grid") {
        // this.searchValue.gridType = this.searchObj.zrqlx;
        // this.searchValue.objid = this.searchObj.objid;
        // }
        if (this.userinfo && this.searchObj) {
          _this.initPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.searchlinLongPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;

  .searchTit {
    width: 100%;
    padding: 0 16px;
    height: 35px;
    background-color: #fff;
    position: relative;

    a {
      display: inline-block;
      width: 55px;
      padding-left: 15px;
      line-height: 35px;
      font-size: 14px;
      color: #4bc08a;
      position: relative;

      .van-icon {
        position: absolute;
        left: 0;
        top: 11px;
        display: inline-block;
        font-size: 14px;
        color: #4bc08a;
        font-weight: 600;
      }
    }

    p {
      width: 200px;
      line-height: 35px;
      margin: 0 auto;
      color: #666;
      text-align: center;
      font-size: 14px;
    }
  }

  .searchBox {
    width: 100%;
    position: relative;

    .van-cell {
      width: 100%;
      height: 45px;
      padding: 8px 16px;
      box-sizing: border-box;

      .van-field__label {
        color: #666;
        font-size: 12px;

        span {
          line-height: 30px;
        }
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 12px;
          line-height: 30px;
        }
      }
    }

    .searchType.van-cell {
      width: 80%;
    }

    .van-button {
      position: absolute;
      right: 16px;
      bottom: 9px;
    }
  }

  .searchMain {
    width: 100%;
    height: calc(100% - 180px);
    overflow-y: scroll;
    background-color: #f6f6f6;
    position: relative;
    .resultList {
      width: 100%;
      padding: 0 8px;

      .item {
        width: 100%;
        background-color: #fff;
        margin: 10px 0;
        padding: 8px 8px;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-borer-radius: 8px;

        p {
          color: #636464;
          font-size: 12px;
          line-height: 20px;
          margin: 5px 0;

          span {
            display: inline-block;
            width: 33.33%;
          }
        }

        p:first-child {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }

    .nonePage {
      width: 120px;
      height: 150px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  .searchMain.hideText {
    .van-list__finished-text {
      display: none;
    }
  }
  .forestStyle {
    position: absolute;
    width: 100%;
    height: calc(100% - 40px);
    top: 40px;
    left: 0;
    padding-top: 40px;
    .zgc {
      position: absolute;
      width: 100%;
      height: 40px;
      background-color: #fff;
      z-index: 9999 !important;
      top: 0;
      left: 0;
      text-align: center;
      color: #646566;
      a {
        display: inline-block;
        width: 45px;
        color: #4bc08a;
        position: absolute;
        left: 16px;
        top: 0px;
        text-align: left;
        .van-icon {
          line-height: 40px;
          display: inline-block;
          font-size: 14px;
          color: #4bc08a;
          font-weight: 600;
        }
      }
    }
  }
}
</style>